const formatLayoutPath = (path: string[]) => path.map((item) => item.replaceAll('_', '-'));

const joinLayoutPath = (path: string[]) => path.join('_');

export const getLayoutPathString = (path: string[]) => {
  const formattedPath = formatLayoutPath(path);
  return joinLayoutPath(formattedPath);
};
